import { render } from "./LeavePlanning.vue?vue&type=template&id=60facbe0&scoped=true"
import script from "./LeavePlanning.vue?vue&type=script&lang=js"
export * from "./LeavePlanning.vue?vue&type=script&lang=js"

import "./LeavePlanning.vue?vue&type=style&index=0&id=60facbe0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60facbe0"]])

export default __exports__